import React from "react";
import { withStyles } from "@material-ui/styles";
import styleConstants from "../../styleConstants";
import backgroundImg from "../../images/rhsc_cga_multi_img_background.png";

const styles = {
  container: {
    backgroundImage: `url(${backgroundImg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    marginBottom: "6rem",
    padding: "4rem 0 6rem"
  },
  titleContainer: {
    display: "grid",
    grid: "1fr 1fr / 1fr"
  },
  title: {
    lineHeight: 1,
    fontSize: "5rem",
    fontWeight: styleConstants.fontWeights.light,
    color: "#ffffff",
    gridArea: "2 / 1 / 3 / 2"
  },
  year: {
    lineHeight: 0.75,
    fontSize: "12rem",
    fontWeight: styleConstants.fontWeights.black,
    color: styleConstants.colors.themeBluePale,
    opacity: 0.3,
    gridArea: "1 / 1 / 3 / 2"
  }
};

const MainTitle = props => (
  <div className={props.classes.container}>
    <div className={props.classes.titleContainer}>
      <div className={props.classes.title}>Commodity Gap Analysis</div>
      <div className={props.classes.year}>2019</div>
    </div>
  </div>
);
export default withStyles(styles)(MainTitle);
